import React, { useState, useRef } from "react";
import "./ExpandableContent.css";

const ExpandableContent = ({ 
  previewText, 
  summaryText, 
  children, 
  className = "" 
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const detailsRef = useRef(null);
  const contentRef = useRef(null);

  // Função para controlar a animação de expansão
  const handleToggle = () => {
    if (!detailsRef.current || !contentRef.current) return;

    const details = detailsRef.current;
    const content = contentRef.current;

    if (details.open) {
      // Fechando - animação de saída
      content.style.animation = 'slideUp 0.3s ease-out forwards';
      setTimeout(() => {
        details.open = false;
        setIsExpanded(false);
        content.style.animation = '';
      }, 300);
    } else {
      // Abrindo - animação de entrada
      details.open = true;
      setIsExpanded(true);
      content.style.animation = 'slideDown 0.3s ease-out forwards';
    }
  };

  return (
    <div className={`expandable-content ${className}`}>
      {previewText && (
        <p className="expandable-text-preview">{previewText}</p>
      )}
      <details 
        ref={detailsRef}
        className="expandable-details"
        open={isExpanded}
      >
        <summary 
          className="expandable-summary"
          onClick={(e) => {
            e.preventDefault();
            handleToggle();
          }}
        >
          <span className="expandable-summary-text">{summaryText}</span>
          <span className={`expandable-expand-icon ${isExpanded ? 'expanded' : ''}`}>▼</span>
        </summary>
        <div ref={contentRef} className="expandable-details-content">
          {children}
        </div>
      </details>
    </div>
  );
};

export default ExpandableContent;
